import {
  CartLine,
  GetDeliveryMomentsResponse,
  GetDeliveryMomentsWithSkuResponse,
  LocationSilo,
  TransportGroup,
  ProductSupplement,
  PackagingInformation,
  OrderingInformation,
} from '@next/core-lib/cart';
import { EntityState } from '@ngrx/entity';

import { LocationSiloWithProductList, SiloProductItem } from 'src/app/components/silos/models/silo-product-list.models';
import { ValidatableSku } from 'src/app/shared/validatable-sku.model';
import { FavoriteSku } from 'src/app/standalone/favorites-star/favorite-sku.model';

import { GetVariant } from './product-delivery.models';
import { SilosInUseOnDates } from './silo.models';

export interface ProductState {
  skuCatalogItems: SkuCatalogItemViewData[];
  skuCatalogItemsNotAvailable?: boolean;
  skuCatalogItemsLoaded?: boolean;
  silos?: EntityState<LocationSilo>;
  silosWithProductList?: EntityState<LocationSiloWithProductList>;
  silosWithProductListLoaded?: boolean;
  silosWithProductListNotAvailable?: boolean;
  silosNotAvailable?: boolean;
  silosLoaded?: boolean;
  silosInUseOnDates?: SilosInUseOnDates[];
  deliveryMoments?: GetDeliveryMomentsResponse;
  deliveryMomentsNotAvailable?: boolean;
  deliveryMomentsLoaded?: boolean;
  variants?: EntityState<GetVariant>;
  variantsNotAvailable?: boolean;
  variantsLoaded?: boolean;
  selectedCartLine: CartLine | null;
  selectedProductSiloLine: SiloProductItem | null;
  proposalDeliveryMoments: EntityState<GetDeliveryMomentsWithSkuResponse>;
  proposalZeroFlexibilityDeliveryMoments: EntityState<GetDeliveryMomentsWithSkuResponse>;
  orderHistorySkuInformation: EntityState<SkuCatalogItemViewData>;
  favoritesLoading?: boolean;
  favoriteSkus: FavoriteSku[];
}

export interface ExpandedSilosState {
  expandedSiloIds: number[];
}

export interface LineItem {
  id: number;
  title: string;
  quantity: number;
  orderUnit: string;
  productSupplements: ProductSupplement[];
}

export interface QuantityItem extends ValidatableSku {
  quantity?: number;
  packagingInformation?: PackagingInformation;
  orderingInformation?: OrderingInformation;
}

export interface SkuCatalogItemViewData extends ValidatableSku {
  externalSkuId: string;
  skuId: number;
  quantity?: number;
  title: string;
  hasProductSupplements?: boolean;
  transportGroup?: TransportGroup;
  packagingInformation?: PackagingInformation;
}

export enum ProductWizardTab {
  QUANTITY = 'QUANTITY',
  DELIVERY_INFORMATION = 'DELIVERY_INFORMATION',
  SILOS = 'SILOS',
  PRODUCT_SUPPLEMENTS = 'PRODUCT_SUPPLEMENTS',
}

export enum ProductlistWizardTab {
  QUANTITY = 'QUANTITY',
  SILOS = 'SILOS',
  PRODUCT_SUPPLEMENTS = 'PRODUCT_SUPPLEMENTS',
}

export enum ProductWizardMode {
  ADD = 'ADD',
  EDIT = 'EDIT',
  CART = 'CART',
}
